import { z } from "zod";
import { FigmaRenderFormat } from "../import";

export const AssetRenderConfiguration = z.object({
  prefix: z.string().optional(),
  suffix: z.string().optional(),
  scale: z.number(),
  format: FigmaRenderFormat,
});

export const RenderedAssetFile = z.object({
  assetPersistentId: z.string(),
  assetName: z.string(),

  renderedImageFileName: z.string(),
  renderedImageUrl: z.string(),

  settings: AssetRenderConfiguration,
});

export type AssetRenderConfiguration = z.infer<typeof AssetRenderConfiguration>;
export type RenderedAssetFile = z.infer<typeof RenderedAssetFile>;
